<app-modal-title>{{title}}</app-modal-title>
<app-modal-body>
    <div class="ot-progress ot-progress--is-bar" style="height: 60%;padding-top: 20px;">
        <div class="ot-progress__outer">
            <div class="ot-progress__meter" [style]="{'width': item.percentage + '%'}">
            </div>
        </div>
        <div class="ot-progress__text" style="padding-left: 15px;">
            {{item.percentage}}%
        </div>
    </div>
    <div style="text-align: center;padding-bottom: 15px;">
        {{text}}
    </div>
</app-modal-body>
<app-modal-footer>
    @if(uploading){
    <button id="logs-package-cancel-button" otsc-button color="primary" (click)="cancel()" i18n>
        Cancel
    </button>
    }
    @else{
    <button id="logs-package-close-button" otsc-button color="primary" [disabled]="uploading" (click)="close()" i18n>
        Close
    </button>
    }
</app-modal-footer>